(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["native-video-file-intersect-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const registerNativeVideoIntersect = () => {
      if (!window.Alpine || window.FAFNativeVideoIntersectRegistered) return;

      window.FAFNativeVideoIntersectRegistered = true;

      window.Alpine.data('nativeVideoIntersect', () => ({
        inView: false,
        paused: true,
        muted: true,
        started: false,
        loading: false,
        playIntent: false,
        userHasInteracted: false,
        autoplay: true,
        loop: true,
        desktopQuery: null,
        reducedMotionQuery: null,
        onBreakpointChange: null,
        onReducedMotionChange: null,
        onVisibilityChange: null,
        onOverlayOpen: null,
        onOverlayClose: null,

        init() {
          this.autoplay = this.$root.dataset.autoplay === 'true';
          this.loop = this.$root.dataset.loop === 'true';
          this.desktopQuery = window.matchMedia('(min-width: 1024px)');
          this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.playIntent = this.autoplay && !this.reducedMotionQuery.matches;

          this.onBreakpointChange = () => this.handleBreakpointChange();
          this.onReducedMotionChange = () => this.handleReducedMotionChange();
          this.onVisibilityChange = () => {
            if (document.hidden) {
              this.pauseForEnvironment();
            } else {
              this.resumeForEnvironment();
            }
          };
          this.onOverlayOpen = () => this.pauseForEnvironment();
          this.onOverlayClose = () => this.resumeForEnvironment();

          this.desktopQuery.addEventListener('change', this.onBreakpointChange);
          this.reducedMotionQuery.addEventListener('change', this.onReducedMotionChange);
          document.addEventListener('visibilitychange', this.onVisibilityChange);
          window.addEventListener('alpine:page:open', this.onOverlayOpen);
          window.addEventListener('alpine:page:close', this.onOverlayClose);

          this.$nextTick(() => this.syncVideoProperties());
        },

        destroy() {
          this.desktopQuery?.removeEventListener('change', this.onBreakpointChange);
          this.reducedMotionQuery?.removeEventListener('change', this.onReducedMotionChange);
          document.removeEventListener('visibilitychange', this.onVisibilityChange);
          window.removeEventListener('alpine:page:open', this.onOverlayOpen);
          window.removeEventListener('alpine:page:close', this.onOverlayClose);
          this.videos().forEach((video) => video.pause());
        },

        videos() {
          return [
            this.$refs.videoUniversal,
            this.$refs.videoDesktop,
            this.$refs.videoMobile,
          ].filter(Boolean);
        },

        activeVideo() {
          if (this.$refs.videoUniversal) return this.$refs.videoUniversal;
          return this.desktopQuery?.matches
            ? this.$refs.videoDesktop
            : this.$refs.videoMobile;
        },

        syncVideoProperties() {
          this.videos().forEach((video) => {
            video.loop = this.loop;
            video.muted = this.muted;
          });
        },

        hydrate(video) {
          if (!video || video.dataset.loaded === 'true' || !video.dataset.src) return;
          video.src = video.dataset.src;
          video.dataset.loaded = 'true';
          video.preload = 'metadata';
          video.load();
        },

        enter() {
          this.inView = true;
          this.resumeForEnvironment();
        },

        leave() {
          this.inView = false;
          this.pauseForEnvironment();
        },

        playActive() {
          const video = this.activeVideo();
          if (!video) return;

          this.hydrate(video);
          video.muted = this.muted;
          video.loop = this.loop;
          this.loading = true;

          video.play()
            .then(() => {
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
              this.paused = true;
            });
        },

        pauseForEnvironment() {
          const video = this.activeVideo();
          if (!video) return;
          video.pause();
        },

        resumeForEnvironment() {
          if (!this.inView || document.hidden || !this.playIntent) return;
          this.playActive();
        },

        togglePlayback() {
          this.userHasInteracted = true;

          if (this.paused) {
            this.playIntent = true;
            this.playActive();
          } else {
            this.playIntent = false;
            this.activeVideo()?.pause();
          }
        },

        toggleMute() {
          this.userHasInteracted = true;
          this.muted = !this.muted;
          this.videos().forEach((video) => {
            video.muted = this.muted;
          });
        },

        handlePlaying(event) {
          if (event.target !== this.activeVideo()) return;
          this.started = true;
          this.paused = false;
          this.loading = false;
        },

        handlePause(event) {
          if (event.target !== this.activeVideo()) return;
          this.paused = true;
          this.loading = false;
        },

        handleError(event) {
          if (event.target !== this.activeVideo()) return;
          this.paused = true;
          this.loading = false;
          this.playIntent = false;
        },

        handleBreakpointChange() {
          this.videos().forEach((video) => video.pause());
          this.started = false;
          this.paused = true;
          this.syncVideoProperties();
          this.resumeForEnvironment();
        },

        handleReducedMotionChange() {
          if (this.reducedMotionQuery.matches && !this.userHasInteracted) {
            this.playIntent = false;
            this.pauseForEnvironment();
            return;
          }

          if (!this.reducedMotionQuery.matches && !this.userHasInteracted) {
            this.playIntent = this.autoplay;
            this.resumeForEnvironment();
          }
        },
      }));
    };

    if (window.Alpine) {
      registerNativeVideoIntersect();
    } else {
      document.addEventListener('alpine:init', registerNativeVideoIntersect, { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppables"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const registerSpriiComponents = () => {
      if (!window.Alpine || window.SpriiPreviewCardRegistered) return;

      window.SpriiPreviewCardRegistered = true;

      window.Alpine.data('spriiNativeClipGallery', () => ({
        observer: null,
        refreshQueued: false,

        init() {
          this.observer = new MutationObserver(() => this.queueRefresh());
          this.observer.observe(this.$el, { childList: true, subtree: true });
          this.$el.addEventListener('sprii-cards-added', () => this.queueRefresh());
          this.$el.addEventListener('sprii-data-loaded', () => this.queueRefresh());
          this.queueRefresh();
        },

        destroy() {
          this.observer?.disconnect();
        },

        queueRefresh() {
          if (this.refreshQueued) return;
          this.refreshQueued = true;

          requestAnimationFrame(() => {
            this.refreshQueued = false;
            this.refreshCards();
          });
        },

        refreshCards() {
          const content = this.$el.querySelector('.sprii-shows-gallery-content');
          if (!content) return;

          const shells = new Set();

          content.querySelectorAll('img[src*="widget.cdn.sprii.shop/images/liveEvent/"]').forEach((image) => {
            const clickWrapper = image.closest('[class*="sprii-cursor-pointer"]');
            const shell = clickWrapper?.querySelector('[class*="sprii-group"]') || clickWrapper;
            if (shell) shells.add(shell);
          });

          shells.forEach((shell) => this.prepareCard(shell));

          const emptyState = document.querySelector(`[data-sprii-native-empty="${CSS.escape(this.$el.id)}"]`);

          if (emptyState) emptyState.hidden = shells.size > 0;
        },

        prepareCard(shell) {
          if (shell.dataset.fafSpriiProcessed === 'true') return;

          const eventImages = Array.from(shell.querySelectorAll('img[src*="widget.cdn.sprii.shop/images/liveEvent/"]'));

          if (eventImages.length < 2) return;

          const animationImage =
            eventImages.find((candidate) => {
              const parentClass = String(candidate.parentElement?.className || '');
              const imageClass = String(candidate.className || '');

              return (
                parentClass.includes('sprii-opacity-0') ||
                parentClass.includes('group-hover:sprii-opacity') ||
                imageClass.includes('sprii-opacity-0') ||
                imageClass.includes('group-hover:sprii-opacity')
              );
            }) || eventImages[1];

          const videoPoster = eventImages.find((candidate) => candidate !== animationImage) || eventImages[0];
          const productImage = Array.from(shell.querySelectorAll('img')).find((candidate) => {
            const source = candidate.currentSrc || candidate.getAttribute('src') || '';
            return (
              candidate !== videoPoster &&
              candidate !== animationImage &&
              (source.includes('cdn.shopify.com') || source.includes('/cdn/shop/'))
            );
          });

          const posterSource = videoPoster.currentSrc || videoPoster.getAttribute('src');
          const animationSource = animationImage.currentSrc || animationImage.getAttribute('src');
          if (!posterSource || !animationSource || !videoPoster.parentElement) return;

          const mainMedia = videoPoster.parentElement;
          mainMedia.dataset.spriiMainMedia = 'true';

          const customCover = this.$el.dataset.spriiCustomCover || '';
          const customCoverSrcset = this.$el.dataset.spriiCustomCoverSrcset || '';
          const customCoverAlt = this.$el.dataset.spriiCustomCoverAlt || '';
          const useSpriiCover = this.$el.dataset.spriiUseCover !== 'false';

          const mainImage = document.createElement('img');
          mainImage.className = 'faf-sprii-main-product-image';
          mainImage.loading = 'lazy';
          mainImage.decoding = 'async';

          if (customCover) {
            mainImage.src = customCover;
            mainImage.alt = customCoverAlt;

            if (customCoverSrcset) {
              mainImage.srcset = customCoverSrcset;
              mainImage.sizes = '(min-width: 1024px) 25vw, (min-width: 640px) 50vw, 100vw';
            }
          } else if (productImage) {
            mainImage.src = productImage.currentSrc || productImage.getAttribute('src');
            mainImage.alt = productImage.alt || '';

            if (productImage.srcset) mainImage.srcset = productImage.srcset;
            if (productImage.sizes) mainImage.sizes = productImage.sizes;
          } else if (useSpriiCover) {
            mainImage.src = posterSource;
            mainImage.alt = videoPoster.alt || '';
          } else {
            mainImage.classList.add('faf-sprii-main-product-image--empty');
            mainImage.alt = '';
          }

          mainMedia.appendChild(mainImage);
          videoPoster.hidden = true;

          if (productImage) productImage.hidden = true;

          const originalAnimationLayer = animationImage.parentElement;
          if (originalAnimationLayer) originalAnimationLayer.hidden = true;

          const miniPlayer = document.createElement('div');
          miniPlayer.className = 'faf-sprii-mini-player';
          miniPlayer.setAttribute('aria-hidden', 'true');

          const miniPoster = document.createElement('img');
          miniPoster.className = 'faf-sprii-mini-player__poster';
          miniPoster.src = posterSource;
          miniPoster.alt = '';
          miniPoster.loading = 'lazy';
          miniPoster.decoding = 'async';

          const miniAnimation = document.createElement('img');
          miniAnimation.className = 'faf-sprii-mini-player__animation';
          miniAnimation.src = animationSource;
          miniAnimation.dataset.spriiPreviewSource = animationSource;
          miniAnimation.alt = '';
          miniAnimation.loading = 'lazy';
          miniAnimation.decoding = 'async';

          const play = document.createElement('span');
          play.className = 'faf-sprii-mini-player__play';
          play.innerHTML = `
            <svg viewBox="0 0 77 77" aria-hidden="true">
              <rect width="75.52" height="75.52" x="0.74" y="0.74" rx="37.76" fill="#000" fill-opacity="0.7" stroke="rgba(255,255,255,0.7)"></rect>
              <path fill="#fff" d="M33.386 49.514V27.487L50.692 38.5z"></path>
            </svg>
          `;

          miniPlayer.append(miniPoster, miniAnimation, play);
          shell.appendChild(miniPlayer);

          shell.dataset.fafSpriiProcessed = 'true';
          shell.classList.add('faf-sprii-native-card-shell');
          shell.setAttribute('x-data', 'spriiNativeClipCard');
          shell.setAttribute('x-bind:class', "{ 'is-previewing': previewing }");
          shell.setAttribute('x-on:mouseenter', 'handleMouseEnter');
          shell.setAttribute('x-on:mouseleave', 'handleMouseLeave');
          shell.setAttribute('x-on:focusin', 'handleFocusIn');
          shell.setAttribute('x-on:focusout', 'handleFocusOut($event)');

          if (!shell._x_dataStack) window.Alpine.initTree(shell);
        },
      }));

      window.Alpine.data('spriiNativeClipCard', () => ({
        previewing: false,
        finePointer: null,
        touchPointer: null,
        intersectionObserver: null,
        pointerChangeHandler: null,

        init() {
          this.finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
          this.touchPointer = window.matchMedia('(hover: none) and (pointer: coarse)');
          this.pointerChangeHandler = () => this.configureTouchPreview();

          if (this.touchPointer.addEventListener) {
            this.touchPointer.addEventListener('change', this.pointerChangeHandler);
          } else {
            this.touchPointer.addListener(this.pointerChangeHandler);
          }

          this.$nextTick(() => this.configureTouchPreview());
        },

        destroy() {
          this.intersectionObserver?.disconnect();

          if (!this.touchPointer || !this.pointerChangeHandler) return;

          if (this.touchPointer.removeEventListener) {
            this.touchPointer.removeEventListener('change', this.pointerChangeHandler);
          } else {
            this.touchPointer.removeListener(this.pointerChangeHandler);
          }
        },

        handleMouseEnter() {
          if (this.finePointer?.matches) this.activatePreview();
        },

        handleMouseLeave() {
          if (this.finePointer?.matches) this.deactivatePreview();
        },

        handleFocusIn() {
          if (this.finePointer?.matches) this.activatePreview();
        },

        handleFocusOut(event) {
          if (!this.finePointer?.matches) return;
          if (event.relatedTarget && this.$el.contains(event.relatedTarget)) return;
          this.deactivatePreview();
        },

        activatePreview() {
          if (this.previewing) return;
          this.previewing = true;
          this.restartAnimation();
        },

        deactivatePreview() {
          this.previewing = false;
        },

        restartAnimation() {
          const image = this.$el.querySelector('.faf-sprii-mini-player__animation');
          if (!image) return;

          const source = image.dataset.spriiPreviewSource || image.getAttribute('src');
          if (!source) return;

          image.dataset.spriiPreviewSource = source;
          image.removeAttribute('src');

          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              if (image.isConnected) image.setAttribute('src', source);
            });
          });
        },

        configureTouchPreview() {
          this.intersectionObserver?.disconnect();
          this.intersectionObserver = null;

          if (!this.touchPointer?.matches || !('IntersectionObserver' in window)) {
            if (!this.finePointer?.matches) this.deactivatePreview();
            return;
          }

          this.intersectionObserver = new IntersectionObserver(
            ([entry]) => {
              if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
                this.activatePreview();
              } else {
                this.deactivatePreview();
              }
            },
            { threshold: [0, 0.6, 1], rootMargin: '-8% 0px -8% 0px' }
          );

          this.intersectionObserver.observe(this.$el);
        },
      }));

      window.Alpine.data('spriiPreviewCard', () => ({
        previewing: false,
        dateReady: false,
        invalidDate: false,
        finePointer: null,
        touchPointer: null,
        intersectionObserver: null,
        dateObserver: null,
        pointerChangeHandler: null,

        init() {
          this.finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
          this.touchPointer = window.matchMedia('(hover: none) and (pointer: coarse)');
          this.pointerChangeHandler = () => this.configureTouchPreview();

          if (this.touchPointer.addEventListener) {
            this.touchPointer.addEventListener('change', this.pointerChangeHandler);
          } else {
            this.touchPointer.addListener(this.pointerChangeHandler);
          }

          this.$nextTick(() => {
            this.watchDate();
            this.configureTouchPreview();
          });
        },

        destroy() {
          this.intersectionObserver?.disconnect();
          this.dateObserver?.disconnect();

          if (!this.touchPointer || !this.pointerChangeHandler) return;

          if (this.touchPointer.removeEventListener) {
            this.touchPointer.removeEventListener('change', this.pointerChangeHandler);
          } else {
            this.touchPointer.removeListener(this.pointerChangeHandler);
          }
        },

        handleMouseEnter() {
          if (this.finePointer?.matches) this.activatePreview();
        },

        handleMouseLeave() {
          if (this.finePointer?.matches) this.deactivatePreview();
        },

        handleFocusIn() {
          if (this.finePointer?.matches) this.activatePreview();
        },

        handleFocusOut(event) {
          if (!this.finePointer?.matches) return;
          if (event.relatedTarget && this.$el.contains(event.relatedTarget)) return;
          this.deactivatePreview();
        },

        activatePreview() {
          if (this.previewing) return;
          this.previewing = true;
          this.restartAnimation();
        },

        deactivatePreview() {
          this.previewing = false;
        },

        restartAnimation() {
          const animation = this.$el.querySelector('[data-sprii-element="video-animation"]');
          if (!animation) return;

          const source = animation.dataset.spriiPreviewSource || animation.getAttribute('src');
          if (!source) return;

          animation.dataset.spriiPreviewSource = source;
          animation.removeAttribute('src');

          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              if (animation.isConnected) animation.setAttribute('src', source);
            });
          });
        },

        configureTouchPreview() {
          this.intersectionObserver?.disconnect();
          this.intersectionObserver = null;

          if (!this.touchPointer?.matches || !('IntersectionObserver' in window)) {
            if (!this.finePointer?.matches) this.deactivatePreview();
            return;
          }

          this.intersectionObserver = new IntersectionObserver(
            ([entry]) => {
              if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
                this.activatePreview();
              } else {
                this.deactivatePreview();
              }
            },
            { threshold: [0, 0.6, 1], rootMargin: '-8% 0px -8% 0px' }
          );

          this.intersectionObserver.observe(this.$el);
        },

        watchDate() {
          const dateWrapper = this.$el.querySelector('.sprii-show-card__date');
          if (!dateWrapper) return;

          const syncDate = () => {
            const value = dateWrapper.textContent.trim();
            this.dateReady = value.length > 0;
            this.invalidDate = /(?:^|\D)1970(?:\D|$)/.test(value);
          };

          syncDate();
          this.dateObserver = new MutationObserver(syncDate);
          this.dateObserver.observe(dateWrapper, {
            childList: true,
            characterData: true,
            subtree: true,
          });
        },
      }));

      requestAnimationFrame(() => {
        document.querySelectorAll('[data-sprii-video-galleries] [x-data]').forEach((element) => {
          if (!element._x_dataStack) window.Alpine.initTree(element);
        });
      });
    };

    document.addEventListener('alpine:init', registerSpriiComponents, { once: true });
    registerSpriiComponents();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sprii-story-shop"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const register = () => {
      if (!window.Alpine || window.FAFSpriiStoryShopRegistered) return;

      window.FAFSpriiStoryShopRegistered = true;

      Alpine.data('spriiStoryShop', (config = {}) => ({
        activeId: String(config.initialId || ''),

        select(id) {
          this.activeId = String(id || '');

          if (!window.matchMedia('(max-width: 1023px)').matches) return;

          this.$nextTick(() => {
            const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

            this.$refs.products?.scrollIntoView({
              behavior: reducedMotion ? 'auto' : 'smooth',
              block: 'start'
            });
          });
        }
      }));
    };

    if (window.Alpine) {
      register();
    } else {
      document.addEventListener('alpine:init', register, { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
